import './../../style/dragDrop.css';
import './../../style/dndSmallScreen.css';
import {randomShuffle } from "./util"
import DragElement from "./DragElement"
import DropElement from "./DropElement"
import { useContext, useEffect, useState } from 'react';
import { isNeitherNullNorUndefined } from '../../utils/functions';
import {adjustListTags } from "../Page/utils/htmlAdjustments"
import {audioBaseURL } from "../../constants"
import {parseContent} from "./util"

export default function DragElementSmall({correctIndex, content, informAboutClick, endClickOnDrag, isClicked}){
    



    useEffect(() => {

    }, [])


    function handleClick(){
        if(isClicked){
            endClickOnDrag()
        } else {
            informAboutClick(correctIndex, content)
        }
    }


    return (
        <div className={isClicked ? 'dndItem dragElement clickedDrag' : 'dndItem dragElement' }
                onClick={handleClick}
        >
        {parseContent(content) &&
            <div className="dndItemContentWrapper ">
                <div className="" 
                    dangerouslySetInnerHTML={{__html: parseContent(content).contentBeforeAudio}}  
                />
                {parseContent(content).audioFileName && <div><audio controls src={audioBaseURL + parseContent(content).audioFileName}  ></audio></div>}
                {parseContent(content).contentAfterAudio && 
                <div className="" 
                    dangerouslySetInnerHTML={{__html: parseContent(content).contentAfterAudio}}  
                /> }
            </div>
            }
    </div>
    
    )
}